export default __webpack_public_path__ + "static/media/fallback_image.084967a8.png";